<!--begin::Body-->
<div class="container">
	<div class="body">
		<div class="logo">
			<a href="#">
				<img src="assets/media/company-logos/logo-2.png" alt="logo Fyffes">
			</a>
		</div>

		<div class="head">
			<h3>{{ 'AUTH.FORGOT.TITLE' | translate }}</h3>
			<h6>{{ 'AUTH.FORGOT.DESC' | translate }}</h6>
		</div>

		<ngb-alert *ngIf="showedAlert" [type]="alert.type" (closed)="closeAlert()">
			{{ alert.message }}
			<button type="button" class="close" aria-label="Close" (click)="closeAlert()">
				<span aria-hidden="true">&times;</span>
			</button>
		</ngb-alert>
		
		

		<form class="form" [formGroup]="forgotPasswordForm" autocomplete="off">
			<div class="form-group">
				<mat-form-field>
					<mat-label class="mat-label">{{ 'AUTH.INPUT.USERNAME' | translate }}</mat-label>
					<input matInput type="username" placeholder="{{ 'AUTH.INPUT.USERNAME' | translate }}" formControlName="username" autocomplete="off" />
					<mat-error *ngIf="isControlHasError('username','required')">
						<strong>{{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}</strong>
					</mat-error>
					<mat-error *ngIf="isControlHasError('username','minLength')">
						<strong>{{ 'AUTH.VALIDATION.MIN_LENGTH_FIELD' | translate }} 3</strong>
					</mat-error>
					<mat-error *ngIf="isControlHasError('username','maxLength')">
						<strong>{{ 'AUTH.VALIDATION.MAX_LENGTH_FIELD' | translate }} 320</strong>
					</mat-error>
				</mat-form-field>
				<mat-form-field>
					<mat-label class="mat-label">{{ 'AUTH.INPUT.EMAIL' | translate }}</mat-label>
					<input matInput type="email" placeholder="{{ 'AUTH.INPUT.EMAIL' | translate }}" formControlName="email" autocomplete="off" />
					<mat-error *ngIf="isControlHasError('email','required')">
						<strong>{{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}</strong>
					</mat-error>
					<mat-error *ngIf="isControlHasError('email','email')">
						<strong>{{ 'AUTH.VALIDATION.INVALID_FIELD' | translate }}</strong>
					</mat-error>
					<mat-error *ngIf="isControlHasError('email','minLength')">
						<strong>{{ 'AUTH.VALIDATION.MIN_LENGTH_FIELD' | translate }} 3</strong>
					</mat-error>
					<mat-error *ngIf="isControlHasError('email','maxLength')">
						<strong>{{ 'AUTH.VALIDATION.MAX_LENGTH_FIELD' | translate }} 320</strong>
					</mat-error>
				</mat-form-field>
			</div>
			<!--begin::Action-->
			<div class="actions" *ngIf="!isMobile || getItem('isPortrait') == 'false'">

				<button mat-raised-button color="btnprimary" (click)="submit()" [disabled]="loading" class="button-login">
					<span *ngIf="!loading" class="button-content">{{ 'AUTH.GENERAL.SUBMIT_BUTTON' | translate }}</span>
					<span *ngIf="loading" class="spinner-container">
						<span class="kt-spinner kt-spinner--md kt-spinner--light"></span>
					</span>
				</button>
				<button mat-raised-button color="btnwhite" routerLink="/auth/login" class="button-login" style="margin-left: 12px">
					&nbsp;
					<ng-container >
						{{ 'AUTH.CHANGE_PASSWORD.CANCEL_BUTTON' | translate }}
					</ng-container>
					&nbsp;
				</button>
			</div>
			<div class="actions" *ngIf="isMobile && getItem('isPortrait') == 'true'">
				<div class="row">
					<button mat-raised-button color="btnprimary" (click)="submit()" [ngClass]="{'kt-spinner kt-spinner--center kt-spinner--md kt-spinner--light': loading}" [disabled]="loading" style="margin-right: 5px">
						&nbsp;
						<ng-container *ngIf="!loading">
							{{ 'AUTH.GENERAL.SUBMIT_BUTTON' | translate }}
						</ng-container>
						&nbsp;
					</button>
					<button mat-raised-button color="btnwhite" routerLink="/auth/login" style="margin-left: 5px">
						&nbsp;
						<ng-container >
							{{ 'AUTH.CHANGE_PASSWORD.CANCEL_BUTTON' | translate }}
						</ng-container>
						&nbsp;
					</button>
				</div>

			</div>
			<!--end::Action-->
		</form>
	</div>
</div>
